import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {dashboardGetEventsCheckedin, signoutToEvent, toggleDialogUnsubscribe, toggleDialogUpdateSubscribe} from '../../../Events/actions';
import DashboardEventsListItem from "./DashboardEventsListItem";
import EventsListItemPlaceholder from "../../../Events/components/List/EventsListItemPlaceholder";
import Button from "@material-ui/core/Button";
import LoadingSpinner from "../../../Layout/components/LoadingSpinner";
import ReactHtmlParser from 'react-html-parser';
import '../../../Events/assets/scss/dialogEventCheckin.css';
import EventDetailsUnsubscribe from '../../../Events/components/Details/EventDetailsUnsubscribe';
import EventDetailsUpdateSubscribe from '../../../Events/components/Details/EventDetailsUpdateSubscribe';
import {withLocalize, Translate} from 'react-localize-redux';
import translations from '../../translations/translations_events';

class DashboardEventsList extends Component {
    state = {
        initialLoad: true,
        eventToUnsubscribe: {}
    };

    constructor(props) {
        super(props);

        this.props.addTranslation(translations);
    }

    componentDidMount() {
        // Fetch the events where the current logged in user is checked in
        this.props.dashboardGetEventsCheckedin(
            1, // No offset
            true, // Reset the search results / listing
        );
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.signupOrOut !== this.props.signupOrOut) {
            if (this.props.signupOrOut) {
                // The user want to unsubscribe, and has been just unsubscribed (signed out)
                // Hide the unsubscribe dialog, and show the confirmation dialog.
                this.setState({
                    eventToUnsubscribe: {}
                });

                // Reload the events
                this.props.dashboardGetEventsCheckedin(
                    1, // No offset
                    true, // Reset the search results / listing
                );
            }
        }
    }

    loadMore = (e) => {
        e.preventDefault();

        const {dashboardEventsLoading, hasMore, currentPage} = this.props.events;

        if (hasMore && !dashboardEventsLoading) {
            this.setState({initialLoad: false});

            this.props.dashboardGetEventsCheckedin(currentPage + 1);
            // TODO search criteria
        }
    };

    handleClickUnsubscribe = (event) => {
        this.setState({
            eventToUnsubscribe: event,
        }, () => {
            this.props.toggleDialogUnsubscribe()
        });
    };

    handleClickUpdate = (event) => {
        this.setState({
            eventToUnsubscribe: event,
        }, () => {
            this.props.toggleDialogUpdateSubscribe()
        });
    };

    render() {
        const {dashboardEventsCheckedin, dashboardEventsLoading, hasMore} = this.props.events;
        const {eventToUnsubscribe} = this.state;

        let placeholders = [];

        for (let i = 0; i < 8; i++) {
            placeholders.push(<EventsListItemPlaceholder key={i}/>);
        }

        let events = [];
        if (!dashboardEventsLoading) {
            if (this.props.filter === 'checkedin') {
                events = dashboardEventsCheckedin;
            } else if (this.props.filter === 'author') {
                events = dashboardEventsLoading;
            }
        }

        let eventToUnsubscribeTitle = '';
        if (Object.keys(eventToUnsubscribe).length) {
            eventToUnsubscribeTitle = eventToUnsubscribe.title;
            if (eventToUnsubscribe.title_html !== '' && eventToUnsubscribe.title_html !== null) {
                eventToUnsubscribeTitle = ReactHtmlParser(eventToUnsubscribe.title_html);
            }
        }

        return (
            <Fragment>
                <section id="events-list">
                    <div className="row">
                        {(dashboardEventsLoading && this.state.initialLoad) && placeholders}
                        {!dashboardEventsLoading && Array.isArray(events) && events.map(event => (
                            <DashboardEventsListItem key={event.id} event={event} handleClickUnsubscribe={this.handleClickUnsubscribe} handleClickUpdate={this.handleClickUpdate} />
                        ))}
                        {(!dashboardEventsLoading && (events.length === 0 || !Array.isArray(events))) &&
                        <div className="col col-12 text-center">
                            {this.props.filter === 'checkedin' &&
                                <p>{this.props.translate('dashboard_events.no_found_checkedin')}</p>
                            }
                            {this.props.filter === 'author' &&
                                <p>{this.props.translate('dashboard_events.no_found_author')}</p>
                            }
                        </div>
                        }
                        {(dashboardEventsLoading && !this.state.initialLoad) && placeholders}
                    </div>
                    {(hasMore && !dashboardEventsLoading) &&
                        <div className="row row-more">
                            <div className="col-3 mx-auto">
                                <div className="text-center">
                                    <Button variant="contained" color="primary" size="medium" onClick={this.loadMore} className="btn-more">
                                        <Translate id="dashboard_events.button_load_more" />
                                    </Button>
                                </div>
                            </div>
                        </div>
                    }
                    {((events === null || dashboardEventsLoading) && !this.state.initialLoad) &&
                        <div className="row row-loading">
                            <div className="col-3 mx-auto">
                                <div className="text-center">
                                    <LoadingSpinner/>
                                </div>
                            </div>
                        </div>
                    }
                </section>

                <EventDetailsUnsubscribe event={eventToUnsubscribe}/>
                <EventDetailsUpdateSubscribe event={eventToUnsubscribe}/>
            </Fragment>
        );
    }
}

DashboardEventsList.propTypes = {
    signoutToEvent: PropTypes.func.isRequired,
    toggleDialogUnsubscribe: PropTypes.func.isRequired,
    toggleDialogUpdateSubscribe: PropTypes.func.isRequired,
    dashboardGetEventsCheckedin: PropTypes.func.isRequired,
    changeFilter: PropTypes.func.isRequired,
    filter: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => ({
    events: state.events,
    signupOrOut: state.events.eventSignupOrOut,
});

export default connect(mapStateToProps, {dashboardGetEventsCheckedin, signoutToEvent, toggleDialogUnsubscribe, toggleDialogUpdateSubscribe})(withLocalize(DashboardEventsList));


// WEBPACK FOOTER //
// ./src/features/Dashboard/components/Events/DashboardEventsList.js